import React, { useState } from 'react';
import { Card } from './ui/card';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { PlusCircle, Trophy, Home, MapPin } from 'lucide-react';

function GameCreator({ onAddGame, seasonName }) {
  const [gameName, setGameName] = useState('');
  const [location, setLocation] = useState(''); // '' (blank/unspecified), 'Home', or 'Away'

  const handleSubmit = (e) => {
    e.preventDefault();
    if (gameName.trim()) {
      onAddGame(gameName.trim(), location || null);
      setGameName('');
      setLocation('');
    }
  };

  const toggleLocation = (type) => {
    if (location === type) {
      setLocation(''); // unselect / leave blank
    } else {
      setLocation(type);
    }
  };

  return (
    <Card className="p-4">
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 items-center">
        {/* Game / Opponent Input */}
        <div className="relative flex-1 w-full">
          <Trophy className="absolute left-3 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input
            type="text"
            value={gameName}
            onChange={(e) => setGameName(e.target.value)}
            placeholder={seasonName && seasonName !== 'All Seasons' ? `Enter opponent / game name for ${seasonName}` : "Enter opponent / game name"}
            className="pl-9"
          />
        </div>

        {/* Optional Home / Away Toggle Group */}
        <div className="flex items-center gap-1 bg-muted/50 p-1 rounded-md border text-xs w-full sm:w-auto justify-center">
          <Button
            type="button"
            size="sm"
            variant={location === 'Home' ? 'default' : 'ghost'}
            onClick={() => toggleLocation('Home')}
            className="h-7 px-2.5 text-xs flex items-center gap-1"
            title="Mark as Home game (optional)"
          >
            <Home className="w-3.5 h-3.5" />
            Home
          </Button>

          <Button
            type="button"
            size="sm"
            variant={location === 'Away' ? 'default' : 'ghost'}
            onClick={() => toggleLocation('Away')}
            className="h-7 px-2.5 text-xs flex items-center gap-1"
            title="Mark as Away game (optional)"
          >
            <MapPin className="w-3.5 h-3.5" />
            Away
          </Button>
        </div>

        {/* Submit Button */}
        <Button type="submit" className="w-full sm:w-auto flex items-center gap-1.5 justify-center shrink-0">
          <PlusCircle className="w-4 h-4" />
          Add Game
        </Button>
      </form>
    </Card>
  );
}

export default GameCreator;
